//
//
//
//

export default {
  props: {
    barData: {
      type: Array, default: () => []
    },
    symbol: {
      type: String, default: 'EURUSD'
    }
  },
  data () {
    return {
      xData: [],
      data1: [],
      data2: [],
      barChart: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.barChart?.resize()
    },
    barData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.barChart?.clear() // 清空当前实例
    this.barChart?.dispose() // 销毁图表
    this.barChart = null
  },
  methods: {
    getData () {
      this.xData = []
      this.data1 = []
      this.data2 = []
      this.barData?.forEach((item) => {
        this.xData.push(item.date)
        this.data1.push({
          name: item.date,
          value: item.data1
        })
        this.data2.push({
          name: item.date,
          value: item.data2
        })
      })
      this.getBarCharts()
    },
    getBarCharts () {
      if (!this.barChart) this.barChart = this.$echarts.init(document.getElementsByClassName('historical-bar-charts')[0])
      const option = {
        grid: {
          top: '20px',
          left: '0px',
          // left: '5%',
          right: '5%',
          bottom: '0px',
          containLabel: true
        },

        tooltip: {
          trigger: 'axis',
          confine: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 0, 0, 0.8)',
          textStyle: {
            color: '#fff',
            fontSize: 14
          },
          axisPointer: {
            type: 'none'
          },
          formatter: (params) => {
            return `<div class="tooltip-box">
            <div class="item">${params[0].name}</div>
            <div class="item">${params[0].seriesName}${params[1].seriesName}</div>
            <div class="item"><span>${this.$t('TYY_000769')}: </span> ${Math.round(params[0].value)}%/${Math.round(params[1].value)}%</div>
            </div>`
          }

        },
        xAxis: [
          {
            type: 'category',
            data: this.xData,
            axisTick: {
              show: false
            },
            axisLabel: {
              color: 'rgba(61, 61, 61, 1)',
              margin: 10
              // formatter (value) {
              //   return value.slice(0, 7)
              // }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            max: '100',
            axisLabel: {
              color: 'rgba(163, 163, 163, 1)',
              formatter (value) {
                return value + '%'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: ['rgba(0, 0, 0, 0.05)']
              }
            }
          }
        ],
        series: [
          {
            name: this.symbol.slice(0, 3),
            type: 'bar',
            itemStyle: {
              color: 'rgba(199, 52, 76, 1)'
            },
            emphasis: {
              itemStyle: {
                color: 'rgba(199, 52, 76, 0.7)'
              }
            },
            data: this.data1
          },
          {
            name: this.symbol.slice(3, 6),
            type: 'bar',
            itemStyle: {
              color: 'rgba(46, 153, 135, 1)'

            },
            emphasis: {
              itemStyle: {

                color: 'rgba(46, 153, 135, 0.7)'
              }
            },
            // barWidth: 10,
            data: this.data2
          }
        ]
      }
      this.barChart?.clear()
      this.barChart?.setOption(option, true)
    }
  }
}
